import { apiClient } from './axiosInstance';
import { IProjectInfoUpdatingData } from '../features/projectInfo/projectInfoTypes';

export const fetchOrganizationProjectInfo = async (projectId: number) => {
  return await apiClient.get(`/projects/${projectId}`);
};

export const updateProjectInfo = async (data: IProjectInfoUpdatingData) => {
  return await apiClient.patch(`/projects/${data.id}`, {
    ...data,
  });
};
